export const CONTENT_KEY = {
  SystemDiagram: "systemDiagram",
  AttackDiagram: "attackGraph",
  ContextDiagram: "contextDiagram",
  // put more content keys here...
};
